import GraphStatistics from "../form/GraphStatistics";

const AllSpotsPage = () => {

  return (
      <GraphStatistics showFriendAddAndBlock={true} />
  );
};
export default AllSpotsPage;
